'use strict';

var $ = global.jQuery;


// Provide deep-linking
if ( window.location.hash ) {
	var hash = window.location.hash,
		tab = $('a[href="' + hash + '"]');

	updateTabs(tab)
}


function updateTabs(tab) {
	var parent = tab.parent(),
		siblings = parent.siblings();

	// Remove active state
	siblings.removeClass('active');

	// Hide sibling target
	siblings.find('[data-toggle]').each(function() {
		var siblingHref = $(this).attr('href');
		$(siblingHref).addClass('hidden');
	});

	// Show target
	var href = tab.attr('href');
	$(href).removeClass('hidden');

	// Add active state
	parent.addClass('active');
}


$('[data-toggle]').on('click', function(e) {
	e.preventDefault();

	var tab = $(this),
		href = tab.attr('href');

	updateTabs(tab);

	// Finally update URL
	history.pushState({}, null, href);
});